module.exports = __webpack_public_path__ + "static/images/video-active.c656eef.png";